// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionOption
export default QuestionOption = class QuestionOption extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  defaults() {
    let data
    return (data = {
      text: "",
      order: 0,
      is_correct_answer: false
    })
  }
}
